<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.exame"
            ref="RkmDataTable"
            sort-by="nome"
        >
            <template v-slot:cell(conectasusExameNome)="{item}">
                <template v-if="item.conectasusExameNome">
                    {{ item.conectasusExameNome }}
                </template>

                <rkm-button
                    v-else
                    @click="$refs.ModalVinculoConectaSusExame.open(item.id)"
                    authorize="edit-web-service-laboratorio-cliente-exame"
                    color="primary"
                    small
                >
                    Vincular exame
                </rkm-button>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="edit(item.id)"
                    authorize="edit-web-service-laboratorio-cliente-exame"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    authorize="destroy-web-service-laboratorio-cliente-exame"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalVinculoConectaSusExame
            @saved="$refs.RkmDataTable.refresh()"
            ref="ModalVinculoConectaSusExame"
        />
    </div>
</template>

<script>
// Components.
import ModalVinculoConectaSusExame from './components/vinculo-conecta-sus-exame/Modal'

// Mixins.
import {error, repository} from '@/mixins'

export default {
    components: {ModalVinculoConectaSusExame},
    created() {
        this.repositories = {
            exame: this.getConectaSusRepository('webService.laboratorio.cliente.exame'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'exame.nome', searchable: true, sortable: true},
            {key: 'conectasusExameNome', label: 'Exame (ConectaSUS)', name: 'conectasusExame.nome', searchable: true, sortable: true},
            {key: 'laboratorioDescricao', label: 'Laboratório', name: 'laboratorioDescricao', searchable: true, sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        edit(id) {
            this.$router.push({name: 'web-service-laboratorio-cliente-exame-edit', params: {id}})
        },
        destroy(item) {
            const destroy = () => this.repositories.exame.destroy(item.laboratorioId, item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o exame?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>